var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M3.99997 2.5L1 5.50003M1 5.50003L3.99997 8.5M1 5.50003L10.5 5.5C12.433 5.5 14 7.067 14 9C14 10.933 12.433 12.5 10.5 12.5H7.00337"}})
}
var staticRenderFns = []

export { render, staticRenderFns }